import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
import { Grid, Col } from '@zendeskgarden/react-grid';
import { wave } from 'utility/customAnimations';

const {
  color_blue_700: colorBlue700,
  color_grey_900: colorGrey900,
  custom_blue: customBlue,
  color_white: colorWhite,
  color_black: colorBlack,
  custom_dark_grey: customDarkGrey,
} = variables;

export const OverlayContainer = styled('div')`
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
`;

export const MainHeader = styled('div')`
  font-size: 30px;
  padding: 15px 10px 5px;
  font-weight: 400;
  color: ${colorBlue700};
  line-height: 34px;
`;

export const DescriptiveParagraph = styled('div')`
  font-size: 14px;
  width: 100%;
  padding: 10px 10px;
  font-weight: 500;
`;

export const ScopeGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  height: 100%;
  max-height: 600px;
  min-width: 700px;
  .titleRow {
    width: 100%;
    justify-content: space-evenly;
  }
  .colTitle {
    display: flex;
    color: ${colorBlue700};
    justify-content: center;
  }
  .dataRow {
    width: 100%;
    justify-content: space-evenly;
    font-size: 14px;
    color: #000;
  }
  .percentage_bubble {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .right {
    border-right: 1px solid ${colorGrey900};
  }
  .bottom {
    border-bottom: 1px solid ${colorGrey900};
  }
`;

export const ScopeGridBlock = styled(Col)`
  font-size: 20px;
  padding: 5px;
`;

export const ScopeListItem = styled('li')`
  display: flex;
  align-items: center;
`;

export const PercentageDiv = styled('div')`
  font-size: 14px;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  background: ${colorWhite};
  color: ${(props) => (props.percentage >= 60 ? colorWhite : colorBlack)};
  .percentage_div {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 0.05rem solid ${customBlue};
    height: 3.1rem;
    width: 3.1rem;
    overflow: hidden;
    border-radius: 1.5rem;
    box-shadow: 1px 1px 7px -2px ${customDarkGrey};
    background: ${(props) =>
      props.percentage >= 60 ? customBlue : colorWhite};
  }
  .percentage_div::before {
    content: '';
    font-size: 1rem;
    background: ${customBlue};
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
  .percentage_div::after {
    content: '';
    position: absolute;
    bottom: 20%;
    left: -20%;
    height: 160%;
    width: 160%;
    background: ${(props) =>
      props.percentage >= 60 ? colorWhite : customBlue};
    border-radius: 35%;
    animation: ${(props) => wave(props.percentage)} 4s ease-in-out forwards;
  }
`;
